import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import SectionHeader from '../components/SectionHeader';
import '../styles/GoalsPage.css';
import SEO from '../components/SEO';
import { GOALS, IMPACT_STATS } from '../data/content';

const GoalsPage: React.FC = () => {
  return (
    <>
      <SEO
        title="Our Goals"
        description="EF21's five organizational goals: improving access to quality education, strengthening educators and local capacity, generating evidence, strengthening community resilience, and organizational excellence."
        keywords="EF21 goals, access to education, teacher capacity, evidence-based programming, community resilience, organizational excellence, Myanmar"
      />
      <Hero
        title="Our Goals"
        subtitle="Five goals guide our programmes and our growth as a national organization"
      />

      <section className="goals-overview">
        <div className="container">
          <SectionHeader
            title="What We Are Working Towards"
            subtitle="Each goal connects our programmes with the priorities identified by the communities we work alongside"
          />

          <div className="timeline">
            <div className="timeline-line"></div>

            {GOALS.map(goal => (
              <div className="timeline-item" key={goal.number}>
                <div className="timeline-content">
                  <h3>Goal {goal.number}: {goal.title}</h3>
                  <p>{goal.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="goals-impact">
        <div className="container">
          <SectionHeader
            title="Our Impact So Far"
            subtitle="Progress against our goals in conflict-affected communities"
          />

          <div className="goals-impact-grid">
            {IMPACT_STATS.map((stat, index) => (
              <div className="goals-impact-card" key={index}>
                <span className="goals-impact-icon" aria-hidden="true">{stat.icon}</span>
                <div className="goals-impact-value">{stat.value}</div>
                <p>{stat.description}</p>
              </div>
            ))}
          </div>

          <div className="goals-cta">
            <Link to="/contact" className="btn">Partner With Us</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default GoalsPage;
